import { createFileRoute } from '@tanstack/react-router';
import DripCampaignsIndexPage from '../../views/dashboard-drip/campaigns';

export const Route = createFileRoute('/dashboard/drip/campaigns/')({
  component: DripCampaignsIndexPage,
});
